// Suppress known service worker promise rejections that occur during offline scenarios
window.addEventListener('unhandledrejection', (event) => {
  // Suppress "Failed to fetch" errors from the service worker
  // These occur when trying to fetch resources that aren't cached during offline mode
  if (
    event.reason &&
    (event.reason.message === 'Failed to fetch' ||
      event.reason.message === 'Network request failed' ||
      (typeof event.reason === 'string' && event.reason.includes('Failed to fetch')))
  ) {
    // Prevent the error from being logged
    event.preventDefault();
    console.debug('Offline fetch attempt (suppressed):', event.reason);
  }
});
